export interface UpdateFacilityScopeDto {
  isActive: boolean; // Required
}
